import apiFetch from '../apiFetch'

export default function (token, body, fleetId) {
  const queryParamsArray = [
    fleetId ? `fleetId=${fleetId}` : null
  ]

  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `UnattendedProcess/SetReEditDocumentFleet${queryParams}`, method: 'POST', body: body, token: token })
}
